
import { StepValidation } from "../trackLeadPayload";

export const loaSteps: StepValidation = {
    personalInfo: ["firstName", "lastName", "email", "phone", "language", "privacyPolicy", "zip"],
    carModel: ["carModel", "constructionYear"],
    paymentPreference: ["desiredFinancingAmount"],
    kbcWidget: [],
}
